import { render, staticRenderFns } from "./ChoiceTypeAddDialog.vue?vue&type=template&id=7e230950&scoped=true&"
import script from "./ChoiceTypeAddDialog.vue?vue&type=script&lang=ts&"
export * from "./ChoiceTypeAddDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ChoiceTypeAddDialog.vue?vue&type=style&index=0&id=7e230950&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e230950",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
